import { DocumentCardComponent } from './document-card/document-card.component';
import { PaneCardComponent } from "./pane-card";
import { TabbedCardComponent } from "./tabbed-card";

export * from "./pane-card";
export * from "./tabbed-card";
export * from './document-card';

export const CardOrganisms = [PaneCardComponent, TabbedCardComponent, DocumentCardComponent];
